import { DefaultApi } from './api'
import { UserData } from './types'

export const me = () =>
  DefaultApi.request<UserData>('/user/me', { method: 'GET', withCredentials: true })

